import I from '../types.ts';

const getLocalFilterName: I['getLocalFilterName'] = function () {
    const { user } = this.props;
    
    return `notifications-${user?.idOfCurrentCorporation}-filter`;
};

export default getLocalFilterName;
